import styled from "styled-components";

const CircleButton = styled.button`
    font-size: 'Inter';
    width: ${(props) => props.size ?? 40}px;
    height: ${(props) => props.size ?? 40}px;
    border-radius: 50%;
    background: ${(props) => props.dark ? 'black' : '#F5F5F5'};
    color: ${(props) => props.dark ? 'white' : 'black'};
    position: relative;
    padding: 12px;
    display: inline-block;

    &:hover{
      background: ${(props) => (!props.dark) ? '#FFE6D1' : 'black'}!important;
      svg path:last-child {
        fill: ${(props) => (!props.dark) ? '#FE902F!important' : 'white'};
      }
    }

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }

    @keyframes rotating {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    &.animate {
        animation: rotating 0.8s linear infinite;
    }
`;

export default CircleButton;
